import request from '@/config/axios'

// 员工 VO
export interface EmployeeVO {
  id?: string | number
  shopId: string | number
  userId?: string | number
  employeeNo: string
  name: string
  phone: string
  positionCode: string
  employmentType: string // EMPLOYEE/PARTNER
  status: string // ACTIVE/LEAVE/RESIGNED
  baseSalary: number
  performanceRatio: number
  hireDate: string
  resignDate?: string
  skills?: string
  idNumber?: string
  emergencyContact?: string
  createTime?: Date
}

// 获取员工分页
export const getEmployeePage = (params: any) => {
  return request.get({ url: '/hotel/employee/page', params })
}

// 获取员工详情
export const getEmployee = (id: string | number) => {
  return request.get({ url: '/hotel/employee/get?id=' + id })
}

// 创建员工
export const createEmployee = (data: EmployeeVO) => {
  return request.post({ url: '/hotel/employee/create', data })
}

// 更新员工
export const updateEmployee = (data: EmployeeVO) => {
  return request.put({ url: '/hotel/employee/update', data })
}

// 删除员工
export const deleteEmployee = (id: string | number) => {
  return request.delete({ url: '/hotel/employee/delete?id=' + id })
}

// 批量删除员工
export const deleteEmployeeList = (ids: (string | number)[]) => {
  return request.delete({ url: '/hotel/employee/delete-list?ids=' + ids.join(',') })
}

// 获取员工简单列表(下拉选择用)
export const getEmployeeListAll = () => {
  return request.get({ url: '/hotel/employee/list-all' })
}
